import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-filter-popover',
  templateUrl: './filter-popover.component.html',
  styleUrls: ['./filter-popover.component.scss'],
})
export class FilterPopoverComponent implements OnInit {
  @Input() listOfValues: { key: string; data: string, count: number }[] = [];
  @Input() checkedListOfValues: { key: string; data: string }[] = [];
  @Input() entityName: any;
  @Input() columnName: any;

  @Output() emitCheckedItems = new EventEmitter<{ key: string; data: string }[]>();

  searchQuery: string = '';
  filteredListOfValues: any[] = [];

  constructor() {}

  ngOnInit() {
    this.updateFilteredList();
  }

  onCheckboxChange(value: { key: string; data: string }, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.checkedListOfValues.push(value);
    } else {
      this.checkedListOfValues = this.checkedListOfValues.filter((item) => item.data !== value.data);
    }
    this.updateFilteredList();
    this.emitCheckedItems.emit(this.checkedListOfValues);
  }

  clearCheckedValues() {
    this.checkedListOfValues = [];
    this.searchQuery = '';
    this.updateFilteredList();
    this.emitCheckedItems.emit(this.checkedListOfValues);
  }

  onSearchInputChange(query: string) {
    this.searchQuery = query;
    this.updateFilteredList();
  }

updateFilteredList() {
  const uncheckedItems = this.listOfValues.filter((item) => {
const itemData = String(item?.data ?? '').toLowerCase();
    const itemKey = String(item?.key ?? '').toLowerCase();
    const searchQuery = String(this.searchQuery ?? '').toLowerCase();
    return (
      !this.checkedListOfValues.find((checked) => checked.data === item.data) &&
        (itemData.includes(searchQuery) || itemKey.includes(searchQuery))
    );
  });

  this.filteredListOfValues = [
    ...this.checkedListOfValues,
    ...uncheckedItems,
  ];
}


  isChecked(value: { key: string; data: string }): boolean {
    return !!this.checkedListOfValues.find((checked) => checked.data === value.data);
  }
}
